//
// Cookie storage
//   - can store json safely, and it will be retrieved as json
//
import {
  flip,
  mapObjIndexed,
} from 'ramda'
import CookieLib from 'js-cookie'

const Cookie = {
  set (key, value) {
    CookieLib.set(key, value, {expires: 30})
  },

  get (key) {
    return CookieLib.getJSON(key)
  },

  remove (key) {
    CookieLib.remove(key)
  },

  removeAll () {
    // CookieLib.get() gets all cookies
    // Should really be forEachObjIndexed, but not available in our current version.
    flip(mapObjIndexed)(CookieLib.get(), (value, key) => {
      CookieLib.remove(key)
    })
  },
}

export default Cookie
